<template>
    <vx-expandable-card>
        <template v-slot:header> Target Teams </template>
        <template v-slot:content>
            <vx-selectable
                v-model="model.target_teams"
                :options="teams"
                @search="searchTeams"
                @option:deselected="deselectCloningTargets"
                :error="displayFirstError(validate.target_teams)"
                label="name"
                multiple
                size="lg"
                :closeOnSelect="false"
            ></vx-selectable>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxSelectable } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { helpers, maxLength, required } from '@vuelidate/validators';
import { ref } from 'vue';
import { adminCloningClient } from '~/services';
import debounce from '~/utils/debounce';
import { displayFirstError } from '~/utils/validation';

const model = defineModel('form', {
    type: Object,
    required: true,
});

const validate = useVuelidate(
    {
        target_teams: {
            required,
            maxLength: helpers.withMessage('Target Teams should not contain more than 500 teams.', maxLength(500)),
        },
    },
    model
);

const teams = ref([]);
const loadingTeams = ref(false);
const searchTeams = debounce((search) => {
    if (loadingTeams.value) {
        return;
    }

    loadingTeams.value = true;

    adminCloningClient
        .getTeams({
            query: search,
            sort_field: 'id',
            sort_dir: 'desc',
            per_page: 100,
        })
        .then((response) => {
            teams.value = response.data.data.map((team) => ({
                ...team,
                name: `${team.id} - ${team.name}`,
            }));
        })
        .finally(() => (loadingTeams.value = false));
}, 350);

searchTeams('');

const deselectCloningTargets = (targetTeam) => {
    model.value.cloning_targets = model.value.cloning_targets.filter(
        (cloningTarget) => !cloningTarget.teams.some((t) => t.id === targetTeam.id)
    );
};
</script>
